export default __webpack_public_path__ + "static/media/Cloudiee.46f82bba.png";